import store from "../../Redux/store";
import {setOwnerData} from "./DashboardOwner.reducer";

export function saveownerData(records) {
  store.dispatch(setOwnerData(records));
}
